import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function ChatSuccess() {

  const [params] = useSearchParams();

  useEffect(() => {

    const bookingId = params.get("bookingId");

    if (!bookingId) return;

    //////////////////////////////////////////////////////
    // CALL YOUR CORRECT BACKEND ROUTE
    //////////////////////////////////////////////////////

    fetch("http://localhost:5000/api/payment/payment-success", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        bookingMongoId: bookingId
      }),
    })
    .then(res => res.json())
    .then(data => {

      if (data.invoiceLink) {

        // open invoice PDF
        window.location.href = data.invoiceLink;

      }

    })
    .catch(err => console.error(err));

  }, []);

  return <h2>Payment successful… generating invoice</h2>;
}